import {Col, Row, Select} from "antd";
import {get} from "helper/request";
import {Component} from "react";
import cookie from "react-cookies";
import {connect} from "react-redux";
import {updateSort} from "../../redux_actions/morpheus.setting.action";
import {changeOrdering} from "../../redux_actions/search.action";


const Option = Select.Option;

class FilterComp extends Component {
    constructor(props) {
        super(props);
        this.handleSortChange = this.handleSortChange.bind(this);
        this.state = {
            valType: undefined,
            valDateRange: undefined,
            devices: [],
        };
    }

    handleSortChange(value) {
        this.props.dispatch(changeOrdering(value, this.props.urlState));
        this.props.dispatch(updateSort({slide_order_by: value}));
    }

    getDevices = () => {
        let url = '/api/get_devices/'
        get(url).then(data => {
            this.setState({
                devices: data['data'],
            })
        })
    }

    componentWillMount = () => {
        this.getDevices();
    }

    render() {
        var isMobile = cookie.loadAll().isMobile === "true";
        let device_options = [
            <Option value={""}>
                All
            </Option>
        ]
        if (this.state.devices.length > 0) {
            for (let i = 0; i < this.state.devices.length; i++) {
                device_options.push(
                    <Option value={this.state.devices[i].id}>
                        {this.state.devices[i].name}
                    </Option>
                )
            }
        }

        return (
            this.props.isFetching === true ?
                <></> :
                <Row style={{ height: isMobile && "6em" }}>
                    <Col span={5}>
                        <Select
                            value={this.props.urlState.ordering}
                            placeholder="Sort List"
                            onChange={this.handleSortChange}
                            style={{width: 130}}
                        >
                            <Option value="name">
                                {" "}
                                A-Z
                            </Option>
                            <Option value="-name">
                                {" "}
                                Z-A
                            </Option>
                            <Option value="date_time">
                                Oldest First
                            </Option>
                            <Option value="-date_time">
                                Recent First
                            </Option>
                        </Select>
                    </Col>
                </Row>
        );
    }
}

const mapStateToProps = state => {
    return {
        isFetching: state.searchReducer.isFetching,
        loginStatus: state.loginAlerts.loginStatus,
        urlState: state.searchReducer,
        morpheusSetting: state.morpheusSettingReducer,
    };
};

export default connect(mapStateToProps)(FilterComp);